import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useQuery } from "@tanstack/react-query";

import { parseWorkerNameForBadgePdf } from "../utils/badgePdf";
import { createWorkBadgePdf } from "../utils/createWorkBadgePdf";

interface UseGetWorkBadgePdfParams {
  qualificationName: string;
  workerHeadshotBase64?: string;
}

export function useGetWorkBadgePdf(params: UseGetWorkBadgePdfParams) {
  const { qualificationName, workerHeadshotBase64 } = params;

  const worker = useDefinedWorker();

  return useQuery({
    queryKey: ["work-badge-pdf", qualificationName, workerHeadshotBase64],
    queryFn: async () => {
      const workerNameDetails = parseWorkerNameForBadgePdf(worker);

      return await createWorkBadgePdf({
        workerDetails: {
          firstName: workerNameDetails.firstName,
          lastName: workerNameDetails.lastName,
          qualificationName,
          profilePictureBase64: workerHeadshotBase64,
        },
      });
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.WORK_BADGE_PDF_GENERATION_FAILURE,
    },
  });
}
